import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import {canPage} from '../../components/ui/PermissionButton';

export default function ProtectedRoute({ children, permission }) {
  const location=useLocation();
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [branchId, setBranchId] = useState(null);

  useEffect(() => {
    fetch("/api/admin/me", {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setUser(data.admin);
          setPermissions(data.permissions || []);
          setBranchId(data.branch_id || null);
        } else {
          setUser(null);
        }
      })
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center bg-black text-white">
        Checking authentication...
      </div>
    );
  }

  // ❌ Not logged in → default admin login
  if (!user) {
    return <Navigate to="/stafflogin" replace />;
  }

  // 🔥 SUPER ADMIN BYPASS
  if (user.role === "super_admin") {
    return children;
  }

  // 🔥 PERMISSION CHECK
  if (!canPage({user,permissions},permission,location.pathname)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}
